import { Theme } from '@astryxdesign/core/theme';
import { Layout, LayoutContent, VStack } from '@astryxdesign/core/Layout';
import { Heading, Text } from '@astryxdesign/core/Text';
import { bootTheme } from '@/theme/tenant-theme';

/** The bare domain shows no studio list: each studio has its own link. */
export function RootPage() {
  return (
    <Theme theme={bootTheme()} mode="dark">
      <Layout
        content={
          <LayoutContent padding={6}>
            <VStack gap={3} hAlign="center" minHeight="80dvh" vAlign="center">
              <Heading level={1} justify="center">
                Автосервис от SGX
              </Heading>
              <Text color="secondary" justify="center" textWrap="balance">
                Откройте ссылку своей студии — она выглядит как /s/название-студии/
              </Text>
            </VStack>
          </LayoutContent>
        }
      />
    </Theme>
  );
}
